<template>
    <DCard
        padding
    >
        <DCardBody>
            <DFormRow
                :label="__('settings.hostlens_mail_settings.form.api_url')"
                :is-required="true"
                :error="errors.api_url"
                :hint="__('settings.hostlens_mail_settings.form.api_url_hint')"
            >
                <DInput
                    id="api-url"
                    v-model="form.api_url"
                    :is-valid="isFormFieldValid('api_url')"
                    maxlength="255"
                />
            </DFormRow>
            <DFormRow
                :label="__('settings.hostlens_mail_settings.form.api_token')"
                :is-required="true"
                :error="errors.api_token"
                :hint="__('settings.hostlens_mail_settings.form.api_token_hint')"
            >
                <DInput
                    id="api-token"
                    v-model="form.api_token"
                    type="password"
                    :is-valid="isFormFieldValid('api_token')"
                    maxlength="255"
                />
            </DFormRow>
            <DRow>
                <DCol sm="4" />
                <DCol sm="4">
                    <div
                        v-if="connectionChecked === true"
                        class="connection-successful"
                    >
                        {{ __('settings.hostlens_mail_settings.connection_successful') }}
                    </div>
                    <div
                        v-if="connectionChecked === false"
                        class="connection-failed"
                    >
                        {{ __('settings.hostlens_mail_settings.connection_unsuccessful') }}
                    </div>
                </DCol>
                <DCol
                    sm="4"
                    class="check-database-connection-btn"
                >
                    <div class="text-right">
                        <DButton
                            class="d-inline-block float-end"
                            type="pa"
                            icon="lan-connect"
                            :label="__('settings.affiliate_settings.check_connection')"
                            :disabled="isInLoadingState"
                            @click="checkConnection"
                        />
                    </div>
                </DCol>
            </DRow>
        </DCardBody>
    </DCard>
    <DFormControls
        :is-dirty="form.isDirty"
        @submit="saveSettings"
    />
</template>

<script setup>
import { useForm } from '@inertiajs/vue3'

import { route } from '~@/Composables/route'
import { ref } from 'vue'

const props = defineProps({
    settings: {
        type: Object,
        default () {
            return {}
        }
    },
    errors: {
        type: Object,
        default () {
            return {}
        }
    }
})
const form = useForm({
    api_url: props.settings.api_url,
    api_token: props.settings.api_key,
})
const connectionChecked = ref(null)
const errors = ref(props.errors)

function saveSettings () {
    form.post(route('settings.hostlens-mail.store'))
}

function checkConnection () {
    window.axios.post(route('settings.hostlens-mail.check'), form)
        .then(function (response) {
            connectionChecked.value = response.data?.success === true
        })
        .catch(function (error) {
            connectionChecked.value = false
            errors.value = error.response.data?.errors ?? {}
        })
}
</script>

<style scoped>
.check-database-connection-btn {
    text-align: right;
    padding-bottom: 25px;
}

.connection-successful {
    color: green;
}

.connection-failed {
    color: red;
}

</style>
